const herbalsGroups = document.querySelectorAll<HTMLElement>('.g-herbals');

herbalsGroups.forEach(group => {
  const title = group.querySelector<HTMLElement>('.g-herbals__title');

  title?.addEventListener('click', () => group.classList.toggle('--opened'));
})
